export default __webpack_public_path__ + "static/media/RCC_dashboard.f9ef42cb.png";